module.exports = __webpack_public_path__ + "img/SkillVisual.e3f374d5.svg";